module.exports = __webpack_public_path__ + "static/media/ice-cream-3.5bbc1295.png";